const _import = require('../import-' + process.env.NODE_ENV)

const heapShelfHeadRouter = [
  {
    path: '/heapShelfHead/home',
    name: 'heapShelfHeadHome',
    component: _import('heapShelfHead/home'),
    meta: {
      title: '端头管理',
      keepAlive: true,
      auth: true
    }
  },
  {
    path: '/heapShelfHead/query',
    name: 'heapShelfHeadQuery',
    component: _import('heapShelfHead/query'),
    meta: {
      title: '端头查询',
      keepAlive: true,
      auth: true
    }
  },
  {
    path: '/heapShelfHead/index',
    name: 'heapShelfHeadIndex',
    component: _import('heapShelfHead/index'),
    meta: {
      title: '端头列表',
      keepAlive: true,
      auth: true
    }
  },
  {
    path: '/heapShelfHead/heap',
    name: 'heapShelfHeadHeap',
    component: _import('heapShelfHead/heap'),
    meta: {
      title: '端头列表',
      auth: true
    }
  },
  {
    path: '/heapShelfHead/goods',
    name: 'heapShelfHeadGoods',
    component: _import('heapShelfHead/goods'),
    meta: {
      title: '',
      auth: true
    }
  },
  {
    path: '/heapShelfHead/report',
    name: 'heapShelfHeadReport',
    component: _import('heapShelfHead/report'),
    meta: {
      title: '',
      auth: true
    }
  },
  {
    path: '/heapShelfHead/report/everyday',
    name: 'heapShelfHeadReportEveryday',
    component: _import('heapShelfHead/report/everyday'),
    meta: {
      title: '',
      auth: true
    }
  },
  {
    path: '/heapShelfHead/report/everydayDetail',
    name: 'heapShelfHeadReportEverydayDetail',
    component: _import('heapShelfHead/report/everydayDetail'),
    meta: {
      title: '',
      auth: true
    }
  }
]
export default heapShelfHeadRouter



// WEBPACK FOOTER //
// ./src/router/work/heapShelfHead.js